module.exports = __webpack_public_path__ + "img/bg-le-lis-blang.e6cc1788.jpg";